import { isValidElement } from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import EntityAvatar from "./EntityAvatar.jsx";
import { colorsFoundation } from "../tokens/colors-foundation.js";
import { dimensions } from "../tokens/dimensions.js";

/**
 * TableEntityCell — the click-dummy's leading table cell: an avatar next to a
 * bold primary line and an optional muted secondary line. Use in a column's
 * `Cell` renderer for the leading column.
 *
 * `avatar` is either a ready EntityAvatar element or a props object forwarded to
 * EntityAvatar (e.g. `{ label }`, `{ icon }`, `{ src }`). Omit it for text-only.
 */
export default function TableEntityCell({ title, subtitle, avatar }) {
  const avatarNode =
    avatar == null ? null : isValidElement(avatar) ? (
      avatar
    ) : (
      <EntityAvatar {...avatar} />
    );

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", gap: dimensions.lg, minWidth: 0 }}
    >
      {avatarNode}
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "0.8125rem",
            lineHeight: 1.3,
            color: "text.primary",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </Typography>
        {subtitle != null && subtitle !== "" && (
          <Typography
            sx={{
              fontSize: "0.75rem",
              lineHeight: 1.3,
              color: colorsFoundation.gray[500],
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

TableEntityCell.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  avatar: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
};
